import { Fade as ChakraFade } from "@chakra-ui/react";
import { useEffect, useRef } from "react";

export default function Fade({
  duration = { enter: 0.3, exit: 0.3 },
  children,
  in: shouldShow,
  onEnter,
  onExit,
  unmountOnExit,
  appear,
  ...rest
}) {
  const isFirstRender = useRef(true);
  const shouldAppear =
    (appear && isFirstRender.current) ||
    (!isFirstRender.current && unmountOnExit);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  const onEnd = () => {
    if (shouldShow) onEnter?.();
    else onExit?.();
  };
  return (
    <ChakraFade
      {...rest}
      onAnimationComplete={onEnd}
      in={shouldShow}
      unmountOnExit={unmountOnExit}
      initial={shouldAppear ? { opacity: 0 } : false}
      transition={{
        enter: {
          duration: duration.enter
        },
        exit: {
          duration: duration.exit
        }
      }}
    >
      {children}
    </ChakraFade>
  );
}
